/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SingleAccommodationForMap } from '../models/SingleAccommodationForMap';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SingleAccommodationForMapService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a SingleAccommodationForMap resource.
     * Retrieves a SingleAccommodationForMap resource.
     * @param id SingleAccommodationForMap identifier
     * @returns SingleAccommodationForMap SingleAccommodationForMap resource
     * @throws ApiError
     */
    public singleAccommodationForMap(id: string): CancelablePromise<SingleAccommodationForMap> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/map/accommodations/{id}',
            path: {
                id: id,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
